import { memo, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal, openModal } from "../../store/actions/modalAction";
import { callApiAction } from "../../store/actions/commonAction";
import { Delete } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import { APP_TYPES, SNACK_BAR_VARIETNS, USER_ROLES } from "../../utils/constants/main";
import { callSnackBar } from "../../store/actions/snackbarAction";
import VersionListUi from "./VersionListUi";
import { unEscapeStr } from "../../utils/helpers/main";
import moment from "moment";
import { deleteVersion, fetchVersiones } from "../../apis/version.api";
import { findObjectKeyByValue } from "../../utils/helpers/main";
import MessageDilog from "../../components/MessageDilog";

const ActionComponent = memo(({ params, setParams, getVersions }) => {
  const dispatch = useDispatch();
  const modalkey = "version";
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user);

  const deleteFun = async (e) => {
    console.log("deleteFun called", modalkey);
    e.preventDefault();
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await deleteVersion({ id: params._id }),
        (response) => {
          setParams({});
          setLoading(false);
          dispatch(
            callSnackBar(
              params.product_name + " Deleted Successfully",
              SNACK_BAR_VARIETNS.suceess
            )
          );
          dispatch(closeModal("versionid"));
          getVersions();
        },
        (err) => {
          setLoading(false);
        }
      )
    );
  };

  const onDelete = () => {
    dispatch(
      openModal(
        <MessageDilog
          onSubmit={deleteFun}
          title="Alert!"
          modalId="versionid"
          message={`Are you sure to delete "${params.name}" Version ?`}
        />,
        "sm",
        false,
        "versionid"
      )
    );
  };

  return (
    <Box sx={{ width: "100%", alignItems: "flex-start", display: "flex" }}>
      {(user.data.role === USER_ROLES.WEHEAR_ADMIN) && (
        <IconButton disabled={loading} size="inherit" onClick={onDelete}>
          <Delete color="error" fontSize="inherit" />
        </IconButton>
      )
      }
    </Box>
  );
});

const VersionListController = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { settings } = useSelector((state) => state);
  const title = "Version"; // Change this to "Product" if needed
  const [list, setList] = useState("production");

  const columns = useMemo(
    () => [
      { id: 1, fieldName: 'launch_date', label: 'Launch Date', align: "left", sort: true, minWidth: '150px', renderValue: (params) => moment(params.launch_date).format("DD/MM/YYYY") },
      { id: 2, fieldName: 'name', label: 'Name', align: "left", sort: true, minWidth: '150px' },

      { id: 3, fieldName: 'main_id', label: 'Version Code', align: "left", sort: true, minWidth: '150px', renderValue: (params) => params.main_version + "." + params.sub_version },
      { id: 4, fieldName: 'app_type', label: 'Type', align: "left", sort: true, renderValue: (params) => findObjectKeyByValue(params.app_type, APP_TYPES) },
      {
        id: 5, fieldName: 'description', label: 'description', align: "left", renderValue: (params) => <Box
          dangerouslySetInnerHTML={{ __html: unEscapeStr(params.description) }}
        />
      },
      {
        id: 6,
        fieldName: "",
        label: "Action",
        align: "right",
        renderValue: (params, setParams) => (
          <ActionComponent params={params} setParams={setParams} getVersions={fetchVersionDataFun} />
        ),
      },
    ],
    []
  );

  const [filters, setFilters] = useState({
    pageNo: 1,
    pageSize: 10,
    search: "",
    searchable: ["name"],
    sort: "createdAt",
    sortDirection: -1,
  });


  const fetchVersionDataFun = () => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () =>
          await fetchVersiones({ ...filters, app_type: APP_TYPES.WEB }),
        (response) => {
          setList(response);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      )
    );
  };
  useEffect(() => {
    fetchVersionDataFun();
  }, [filters]);

  return (
    <>
      <VersionListUi
        title={title}
        filters={filters}
        setFilters={setFilters}
        loading={loading}
        columns={columns}
        list={list}
        setList={setList}
        getVersions={fetchVersionDataFun}
      />
    </>
  );
};
export default VersionListController;
